import request from "@/utils/requestSC";

// 获取渠道店铺列表
export async function getzntScShopList(params) {
  return request.get("/mob/shop/zntSc/shopList", { params });
}

// 获取养殖会员活动楼层列表
export async function getActivityFloorList(params) {
  return request.get(`api/platform/activity/${params}`);
}

// 获取养殖会员活动楼层商品列表
export async function getActivityGoodList(params) {
  return request.get("api/platform/activity/goodsList", { params });
}

// 获取预估 （本年，本月，本周，今日）
export async function queryRecommendPointsMap() {
  return request.get("/rest/order/queryRecommendPointsMap");
}

// 获取累计
export async function queryPointsByPtType(params) {
  return request.get("/rest/points/queryPointsByPtType", {
    params
  });
}

// 获取订单列表
export async function queryRecommendPointsOrderList(params) {
  return request.get("/rest/order/queryRecommendPointsOrderList", {
    params
  });
}
